var fails = require('../internals/fails');

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/correct-prototype-getter.js
// module id = 1659
// module chunks = 1